import styles from "./Dashboard.module.css";
import Sidebar from "../sidebar/Sidebar";
import { useState} from "react"
import SidebarStyles from "../sidebar/Sidebar.module.css";
import MainContainer from "../mainContainer/MainContainer";
import TokensDisplay from "../Overview/Tokens/TokensDisplay/TokensDisplay";
import PoolsDisplay from "../Overview/Pools/PoolsDisplay/PoolsDisplay";

// sidebar
import { FiHelpCircle } from "react-icons/fi";
import { VscGraphLine } from "react-icons/vsc";
import { GiToken } from "react-icons/gi";
import { BsFillPersonFill } from "react-icons/bs";
import { GiJellyfish } from "react-icons/gi";
import { MdSpaceDashboard } from "react-icons/md";

const Dashboard = () => {
  const [currentDashboard, setCurrentDashboard] = useState("home")
  const [ dashboardDisplay, setDashboardDisplay] = useState(false)

  const myStyle = dashboardDisplay ? styles.Dashboard : styles.Home;

  // sidebar
  const Sidebar = (
    <div className={SidebarStyles.aside}>
      <div className={SidebarStyles.brand}>
        <GiJellyfish />
      </div>
      <ul className={SidebarStyles.links}>
        <li className={currentDashboard === "home" ? SidebarStyles.selected : null} onClick={() => setCurrentDashboard("home")}>
          <MdSpaceDashboard />
        </li>
        <li onClick={() => setCurrentDashboard("pools")} className={currentDashboard === "pools" ? SidebarStyles.selected : null}>
          <VscGraphLine />
        </li>
        <li onClick={() => setCurrentDashboard("tokens")} className={currentDashboard === "tokens" ? SidebarStyles.selected : null}>
          <GiToken />
        </li>

        <li>
          <BsFillPersonFill />
        </li>
      </ul>
      <div className={SidebarStyles.help}>
        <FiHelpCircle />
      </div>
    </div>
  );
  // End of sidebar

  const DashboardToDisplay = () => {
    if (currentDashboard === "home") {
      return <MainContainer/>;
    } else if (currentDashboard === "tokens") {
      return <TokensDisplay/>;
    } else if (currentDashboard === "pools") {
      return <PoolsDisplay/>
    }
  }

  const DashboardDisplay = DashboardToDisplay()

  return (
    <div className={myStyle}>
      {Sidebar}
      <div className={styles.container}>
        {/* {dashboardDisplay ? <MainContainer /> : <TokensDisplay />} */}
        {DashboardDisplay}
      </div>
    </div>
  );
};

export default Dashboard;
